function applyStickyTransforms(container) {
  if (!container) return

  const { scrollLeft, scrollTop } = container
  const frozenColumns = container.querySelectorAll('.sticky')
  const stickyHeader = container.dataset.stickyHeader === 'true'

  frozenColumns.forEach((column) => {
    const isHeader = column.closest('thead')
    if (isHeader && stickyHeader) {
      column.style.transform = `translate(${scrollLeft}px, ${scrollTop}px)`
    } else {
      column.style.transform = `translateX(${scrollLeft}px)`
    }
  })

  // Apply vertical sticky to all non-sticky header cells (only if sticky header is enabled)
  if (stickyHeader) {
    const headerCells = container.querySelectorAll('thead th')
    headerCells.forEach((cell) => {
      if (!cell.classList.contains('sticky')) {
        cell.style.transform = `translateY(${scrollTop}px)`
      }
    })
  }
}

function truncate(text, limit = 30) {
  if (typeof text !== 'string') return ''
  return text.length <= limit ? text : `${text.slice(0, limit - 3)}...`
}

// Swap a lazy trait cell (value-only <td> rendered by
// account_samples/_cell_trait) for the real inline editor, cloned from the
// column's <template> (account_samples/_cell_trait_form_template). Must stay
// synchronous: inline-editable-form's keyboard navigation materializes the
// target cell mid-keydown and focuses its field in the same task.
// Returns true when the cell is (or already was) editable in place.
function materializeLazyCell(td) {
  if (!td || !td.dataset || td.dataset.lazyCellTraitId === undefined) {
    // Not a lazy cell (eager cell or non-trait column) — nothing to do.
    return true
  }
  if (td.querySelector('[data-controller~="inline-editable-form"]')) return true // already materialized

  const template = document.querySelector(`template[data-lazy-cell-form="${td.dataset.lazyCellTraitId}"]`)
  if (!template) return false

  const fragment = template.content.cloneNode(true)
  const wrapper = fragment.firstElementChild

  const form = wrapper.querySelector('form')
  if (!form) return false
  form.setAttribute('action', td.dataset.lazyCellUrl)
  if (td.dataset.lazyCellMethod === 'patch') {
    const methodInput = document.createElement('input')
    methodInput.type = 'hidden'
    methodInput.name = '_method'
    methodInput.value = 'patch'
    form.appendChild(methodInput)
  }

  const field = wrapper.querySelector('[data-target~="inline-editable-form.field"]')
  if (field) {
    field.value = td.dataset.lazyCellValue || ''
    if (field.tagName === 'INPUT') field.setAttribute('value', field.value)
    // Seed originalValue before inline-editable-form connects, mirroring what
    // setOriginalValue would read from a server-rendered form.
    $(field).data('originalValue', field.value)
  }

  const unitSelect = wrapper.querySelector('select[name="sample_trait[unit]"]')
  if (unitSelect && td.dataset.lazyCellUnit) unitSelect.value = td.dataset.lazyCellUnit

  // Carry the rendered display (value + unit label) into the editor's .value.
  const display = td.querySelector('.value')
  const editorValue = wrapper.querySelector('.value')
  if (display && editorValue) editorValue.innerHTML = display.innerHTML

  td.innerHTML = ''
  td.appendChild(wrapper)
  return true
}

export { truncate, applyStickyTransforms, materializeLazyCell }
